<template>
  <div
    class="font-secondary text-[14px] leading-[22px] text-gray-800"
    :class="useMobileLayout ? 'overflow-auto p-4' : ''"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'

const { isMobile } = useDevice()
const isModal = inject<boolean>('dialogModal', false)
const useMobileLayout = isMobile.value && !isModal
</script>
